import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";

export const logger = LazyLoadingSectionLogger.create(LoggingSection.mainMenu);
